import React, { useState } from 'react';

import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EntryPopup from './entryPopup';
import AddMenu from './addMenu';
import EntryTable from './entryTable';

import { collection, doc, getDocs } from "firebase/firestore";
import { database } from '../firebaseConfig2';

//get collection info
const querySnapshot = await getDocs(collection(database, "mkcp_blorbos"));


export default function Blorbos() {

//table info

const columns = [
  { id: 'date', label: 'Date', minWidth: 100 },
  { id: 'img', label: 'Image', maxWidth: 100 },
  { id: 'name', label: 'Name', minWidth: 100 },
  { id: 'origin', label: 'Origin', minWidth: 100 },
  { id: 'origin_link', label: 'Link', minWidth: 100 },
  { id: 'message', label: 'Message', minWidth: 100 },
];

const rows = [];
querySnapshot.forEach((doc) => {
  let temprow =
    {
      id: doc.id, 
      date: doc.data().date,
      img: doc.data().img, 
      name: doc.data().name,
      origin: doc.data().origin,
      origin_link: doc.data().origin_link,
      message: doc.data().message
    }
    if (!rows.includes(temprow)){
      rows.push(temprow);
    }
});

//other
  const [addMenu, setAddMenu] = useState(false);
  const [updater, triggerUpdate] = useState(0);
  const [entryPopup, openPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  const handleMenu = (mybool) =>{
    setAddMenu(true);
    console.log("inhandlemenu")
  }
  return (
    <>
        <EntryTable querySnapshot={querySnapshot} columns={columns} rows={rows} tableName="mkcp_blorbos" updater={updater}  entryPopup={entryPopup} openPopup={openPopup} selectedRow={selectedRow} setSelectedRow={setSelectedRow}/>
        <div style={{ display: entryPopup ? 'block' : 'none' }}>
          <EntryPopup querySnapshot={querySnapshot} tableName="mkcp_blorbos" entryPopup={entryPopup} openPopup={openPopup} selectedRow={selectedRow} setSelectedRow={setSelectedRow}/>
        </div>
        <Fab id="addbtn" color="primary" aria-label="add" onClick={()=>handleMenu(true)}>
          <AddIcon />
        </Fab>
        <div className='menucontainer' style={{ display: addMenu ? 'block' : 'none' }}>
          <AddMenu querySnapshot={querySnapshot} tableName="mkcp_blorbos" addMenu={addMenu} setAddMenu={setAddMenu} updater={updater} triggerUpdate={triggerUpdate}/>
        </div>
    </>
  );
}